export type HelpLinks = {
  mainDashboardOverview: string
  dataRoomDashboardOverview: string
  addShareholderIndividual: string
  addShareholderInstitutional: string
  addShareClass: string
  addConvertibleClass: string
  addWarrantClass: string
  addShareTransaction: string
  addConvertibleIssuance: string
  addWarrantIssuance: string
  addBuybackShare: string
  addTransferShare: string
  addBankDetails: string
  addBoardMemberPersonalDetails: string
  addBoardMemberAddress: string
  addBoardMemberOtherDetails: string
  addBoardMemberDocuments: string
  addFounderPromoterDetails: string
  addFounderPromoterExperienceModal: string
  addTeamMember: string
  addLegalComplianceDetailsIndividual: string
  addLegalComplianceDetailsInstitutional: string
  addFinanceAccountsDetailsIndividual: string
  addFinanceAccountsDetailsInstitutional: string
  addAdvisorsMentorsIndividual: string
  addAdvisorsMentorsInstitutional: string
  complianceMeetingScheduleNewMeetingPhysical: string
  complianceMeetingScheduleNewMeetingVirtual: string
  complianceMeetingPostMeetingDetails: string
  digitalSigningDashboardOverview: string
  digitalSigningCreateDocument: string
  captableManagementDashboardOverview: string
  captableManagementCreateScenario:string
  sharedAccessInbox: string
  sharedAccessAiGeneratedEmail: string
  sharedAccessAiGeneratedReplies: string
  sharedAccessCalendar: string
  sharedAccessCalenderNewEvent: string
  sharedAccessContacts: string
  sharedAccessContactDetails: string
  sharedAccessContactsGroup: string
  publishCofounderDetails: string
  onBoardingCompanyDetails: string
  onBoardingInitializeRound: string
  onBoardingFundingRound: string
  onBoardingTeamMember: string
  founderMarketEditDeal: string
  startupShowcaseAddDeal: string
}

export const helpLinksFoundercrate: HelpLinks = {
  mainDashboardOverview:
    'https://help.foundercrate.com/en/articles/9163417-how-to-utilize-your-dashboard-on-foundercrate-to-make-fundraising-process-streamlined',
  dataRoomDashboardOverview:
    'https://help.foundercrate.com/en/articles/9164877-mastering-the-data-room-feature-on-foundercrate',
  addShareholderIndividual:
  'https://help.foundercrate.com/en/articles/9690892-adding-individual-shareholders-to-your-foundercrate-portal',
  addShareholderInstitutional:
  'https://help.foundercrate.com/en/articles/9699297-adding-institutional-investors-to-your-foundercrate-portal',
  addShareClass: 'https://help.foundercrate.com/en/articles/9700795-adding-investor-share-class-details-on-foundercrate',
  addConvertibleClass: 'https://help.foundercrate.com/en/articles/9701071-adding-and-managing-convertible-class-on-foundercrate',
  addWarrantClass: 'https://help.foundercrate.com/en/articles/9705795-adding-and-managing-warrant-class-details-on-foundercrate',
  addShareTransaction: 'https://help.foundercrate.com/en/articles/9705985-adding-and-managing-share-transactions-on-foundercrate',
  addConvertibleIssuance: 'https://help.foundercrate.com/en/articles/9705996-adding-and-managing-convertible-issuances-on-foundercrate',
  addWarrantIssuance: 'https://help.foundercrate.com/en/articles/9706010-adding-and-managing-warrant-issues-on-foundercrate',
  addBuybackShare: 'https://help.foundercrate.com/en/articles/9706021-adding-and-managing-share-buyback-details-on-foundercrate',
  addTransferShare: 'https://help.foundercrate.com/en/articles/9706100-adding-and-managing-share-transfer-details-on-foundercrate',
  addBankDetails: 'https://help.foundercrate.com/en/articles/9705806-adding-and-managing-bank-and-nominee-details-on-foundercrate',
  addBoardMemberPersonalDetails: 'https://help.foundercrate.com/en/articles/9673587-seamlessly-add-board-members-to-your-foundercrate-portal',
  addBoardMemberAddress: 'https://help.foundercrate.com/en/articles/9673664-adding-official-address-details-for-a-board-member-on-foundercrate',
  addBoardMemberOtherDetails: 'https://help.foundercrate.com/en/articles/9674077-filling-in-important-stakeholder-details-on-foundercrate',
  addBoardMemberDocuments: 'https://help.foundercrate.com/en/articles/9680302-uploading-important-documents-to-stakeholder-profiles-on-foundercrate',
  addFounderPromoterDetails: 'https://help.foundercrate.com/en/articles/9706120-adding-and-managing-founders-as-stakeholders-on-foundercrate',
  addFounderPromoterExperienceModal: 'https://help.foundercrate.com/en/articles/9705985-adding-and-managing-share-transactions-on-foundercrate',
  addTeamMember: 'https://help.foundercrate.com/en/articles/9706219-adding-and-managing-management-team-members-on-foundercrate ',
  addLegalComplianceDetailsIndividual: 'https://help.foundercrate.com/en/articles/9706267-adding-and-managing-legal-compliance-team-members-on-foundercrate',
  addLegalComplianceDetailsInstitutional: 'https://help.foundercrate.com/en/articles/10025938-how-to-add-legal-and-compliance-entities-to-your-foundercrate-account',
  addFinanceAccountsDetailsIndividual: 'https://help.foundercrate.com/en/articles/9706360-adding-and-managing-finance-accounts-team-members-on-foundercrate',
  addFinanceAccountsDetailsInstitutional:'https://help.foundercrate.com/en/articles/10025999-guide-to-adding-finance-and-accounts-entities-to-your-foundercrate-dashboard',
  addAdvisorsMentorsIndividual: 'https://help.foundercrate.com/en/articles/9706405-adding-and-managing-advisors-mentors-on-foundercrate-for-enhanced-guidance',
  addAdvisorsMentorsInstitutional: 'https://help.foundercrate.com/en/articles/10025916-guide-to-adding-organizations-as-advisors-or-mentors-in-foundercrate',
  complianceMeetingScheduleNewMeetingPhysical: 'https://help.foundercrate.com/en/articles/9973803-learn-to-schedule-and-manage-physical-compliance-meetings-on-foundercrate',
  complianceMeetingScheduleNewMeetingVirtual: 'https://help.foundercrate.com/en/articles/9716746-scheduling-and-managing-virtual-compliance-meetings-on-foundercrate',
  digitalSigningDashboardOverview:'https://help.foundercrate.com/en/articles/9565087-simplify-your-workflow-with-foundercrate-s-digital-signing-feature',
  digitalSigningCreateDocument: 'https://help.foundercrate.com/en/articles/9684935-uploading-new-documents-for-digital-signing-on-foundercrate',
  captableManagementDashboardOverview: 'https://help.foundercrate.com/en/articles/9924584-how-to-streamline-your-cap-table-management-with-foundercrate',
  captableManagementCreateScenario:'https://help.foundercrate.com/en/articles/9924596-how-to-conduct-scenario-analysis-in-foundercrate-s-cap-table-management',
  complianceMeetingPostMeetingDetails: 'https://help.foundercrate.com/en/articles/9716723-adding-and-managing-post-meeting-details-for-compliance-meetings-on-foundercrate',
  sharedAccessInbox: 'https://help.foundercrate.com/en/articles/9507134-streamline-your-communication-with-foundercrate-s-shared-access',
  sharedAccessAiGeneratedEmail: 'https://help.foundercrate.com/en/articles/9513127-enhance-your-email-communication-with-ai-generated-drafts-in-foundercratehttps://help.foundercrate.com/en/articles/9513127-enhance-your-email-communication-with-ai-generated-drafts-in-foundercrate',
  sharedAccessAiGeneratedReplies: 'https://help.foundercrate.com/en/articles/9507844-enhance-your-communication-with-ai-powered-email-replies-in-foundercrate',
  sharedAccessCalendar: 'https://help.foundercrate.com/en/articles/9520264-optimize-your-scheduling-with-foundercrate-s-two-way-calendar-sync',
  sharedAccessCalenderNewEvent: 'https://help.foundercrate.com/en/articles/9513262-master-your-schedule-with-foundercrate-s-integrated-calendar',
  sharedAccessContacts: 'https://help.foundercrate.com/en/articles/9513171-effortlessly-add-and-manage-contacts-with-foundercrate-s-shared-access-feature',
  sharedAccessContactDetails: 'https://help.foundercrate.com/en/articles/9513228-accessing-comprehensive-contact-details-and-schedules-in-foundercrate',
  sharedAccessContactsGroup: 'https://help.foundercrate.com/en/articles/9513211-streamline-your-communication-creating-contact-groups-in-foundercrate',
  publishCofounderDetails: 'https://help.foundercrate.com/en/articles/9983452-how-to-find-and-connect-with-a-co-founder-on-foundercrate',
  onBoardingCompanyDetails:'https://help.foundercrate.com/en/articles/9330202-importance-of-company-details-for-optimizing-your-foundercrate-account-setup',
  onBoardingInitializeRound:'https://help.foundercrate.com/en/articles/8223229-exploring-funding-rounds-on-foundercrate',
  onBoardingFundingRound: 'https://help.foundercrate.com/en/articles/9330376-understanding-funding-rounds-and-their-importance-on-foundercrate',
  onBoardingTeamMember: 'https://help.foundercrate.com/en/articles/9330426-making-collaborations-a-norm-with-foundercrate-s-team-feature',
  founderMarketEditDeal: 'https://help.foundercrate.com/en/articles/9951400-how-to-publish-your-startup-for-voting-on-foundercrate',
  startupShowcaseAddDeal: 'https://help.foundercrate.com/en/articles/9951400-how-to-publish-your-startup-for-voting-on-foundercrate',
}

export const helpLinksRecordskeeper: HelpLinks = {
  mainDashboardOverview: 'https://help.recordskeeper.ai/en/articles/10357445-recordskeeper-ai-your-complete-guide-to-intelligent-record-management',
  dataRoomDashboardOverview: 'https://help.recordskeeper.ai/en/articles/11070255-mastering-the-secure-data-room-feature-on-recordskeeper-ai',
  addShareholderIndividual: 'https://help.recordskeeper.ai/en',
  addShareholderInstitutional: 'https://help.recordskeeper.ai/en',
  addShareClass: 'https://help.recordskeeper.ai/en',
  addConvertibleClass: 'https://help.recordskeeper.ai/en',
  addWarrantClass: 'https://help.recordskeeper.ai/en',
  addShareTransaction: 'https://help.recordskeeper.ai/en',
  addConvertibleIssuance: 'https://help.recordskeeper.ai/en',
  addWarrantIssuance: 'https://help.recordskeeper.ai/en',
  addBuybackShare: 'https://help.recordskeeper.ai/en',
  addTransferShare: 'https://help.recordskeeper.ai/en',
  addBankDetails: 'https://help.recordskeeper.ai/en',
  addBoardMemberPersonalDetails: 'https://help.recordskeeper.ai/en',
  addBoardMemberAddress: 'https://help.recordskeeper.ai/en',
  addBoardMemberOtherDetails: 'https://help.recordskeeper.ai/en',
  addBoardMemberDocuments: 'https://help.recordskeeper.ai/en',
  addFounderPromoterDetails: 'https://help.recordskeeper.ai/en',
  addFounderPromoterExperienceModal: 'https://help.recordskeeper.ai/en',
  addTeamMember: 'https://help.recordskeeper.ai/en',
  addLegalComplianceDetailsIndividual: 'https://help.recordskeeper.ai/en',
  addLegalComplianceDetailsInstitutional: 'https://help.recordskeeper.ai/en',
  addFinanceAccountsDetailsIndividual: 'https://help.recordskeeper.ai/en',
  addFinanceAccountsDetailsInstitutional:'https://help.recordskeeper.ai/en',
  addAdvisorsMentorsIndividual: 'https://help.recordskeeper.ai/en',
  addAdvisorsMentorsInstitutional: 'https://help.recordskeeper.ai/en',
  complianceMeetingScheduleNewMeetingPhysical: 'https://help.recordskeeper.ai/en/articles/10884401-how-to-schedule-and-manage-compliance-meetings-with-recordskeeper-ai',
  complianceMeetingScheduleNewMeetingVirtual: 'https://help.recordskeeper.ai/en',
  complianceMeetingPostMeetingDetails: 'https://help.recordskeeper.ai/en',
  digitalSigningDashboardOverview:'https://help.recordskeeper.ai/en/articles/10869926-digital-signing-with-recordskeeper-ai-a-comprehensive-guide',
  digitalSigningCreateDocument: 'https://help.recordskeeper.ai/en',
  captableManagementDashboardOverview: 'https://help.recordskeeper.ai/en',
  captableManagementCreateScenario:'https://help.recordskeeper.ai/en',
  sharedAccessInbox: 'https://help.recordskeeper.ai/en',
  sharedAccessAiGeneratedEmail: 'https://help.recordskeeper.ai/en',
  sharedAccessAiGeneratedReplies: 'https://help.recordskeeper.ai/en',
  sharedAccessCalendar: 'https://help.recordskeeper.ai/en',
  sharedAccessCalenderNewEvent: 'https://help.recordskeeper.ai/en',
  sharedAccessContacts: 'https://help.recordskeeper.ai/en',
  sharedAccessContactDetails: 'https://help.recordskeeper.ai/en',
  sharedAccessContactsGroup: 'https://help.recordskeeper.ai/en',
  publishCofounderDetails: 'https://help.recordskeeper.ai/en',
  onBoardingCompanyDetails:'https://help.recordskeeper.ai/en',
  onBoardingInitializeRound:'',
  onBoardingFundingRound: '',
  onBoardingTeamMember: '',
  founderMarketEditDeal: '',
  startupShowcaseAddDeal: '',
}
